var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("companies") }, "col-lg-6"] },
        [
          _c("label", { attrs: { for: "companies" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("companies")))
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.company_ids,
                  expression: "company_ids"
                }
              ],
              staticClass: "form-control m-bootstrap-select m_selectpicker",
              attrs: {
                id: "companies",
                name: "companies",
                multiple: "",
                title: _vm._f("translate")("select_an_option")
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.company_ids = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectAllCompanies
                ]
              }
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("all")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.companies, function(company, key) {
                return _c(
                  "option",
                  { key: key, domProps: { value: company.id } },
                  [_vm._v("\n          " + _vm._s(company.name) + "\n        ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("companies"),
                  expression: "errors.has('companies')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("companies")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("auth_types") }, "col-lg-6"] },
        [
          _c("label", { attrs: { for: "auth_types" } }, [
            _vm._v(
              _vm._s(
                _vm._f("capitalize")(_vm._f("translate")("authorized_type"))
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.auth_types_ids,
                  expression: "auth_types_ids"
                }
              ],
              staticClass: "form-control m-bootstrap-select m_selectpicker",
              attrs: {
                id: "auth_types",
                name: "auth_types",
                multiple: "",
                title: _vm._f("translate")("select_an_option")
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.auth_types_ids = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectAllAuthTypes
                ]
              }
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("all")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.auth_types, function(auth_type, key) {
                return _c(
                  "option",
                  { key: key, domProps: { value: auth_type.id } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(auth_type.name) + "\n        "
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("auth_type"),
                  expression: "errors.has('auth_type')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("auth_type")) + " ")]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12", staticStyle: { "text-align": "right" } },
        [
          _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success m-btn m-btn--icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.generateReport()
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "la la-archive" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("generate_report")
                      )
                    )
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b62e9d7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b62e9d7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/reports/forms/PresentPersonalForm.vue
// module id = 501
// module chunks = 0 1 4 40